import Model, { attr } from '@ember-data/model';

import type { DSSetup, MetricAnomalies } from 'webapp-types';

export default class MetricAnomalyRecord extends Model {
	@attr('string') metricSetupKey!: string | null;
	@attr('number') metricSetupSpaceAccessId!: number | null;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	metricSetupDimensions!: string[];
	@attr('object') metricSetupFilters!: DSSetup.MetricSetupFiltersData | null;
	@attr('object') settings!: MetricAnomalies.Settings;
}
